import React, { useEffect, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import BtnLight from "../../../../common/element/Buttons/btnLight";
import Button from "../../../../common/element/Buttons";
import BtnPrimary from "../../../../common/element/Buttons/btnPrimary";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ProviderRegisterPaymentInfo } from "../../../../actions/public/ProviderRegisterPaymentInfo";
import { SignupProviderForClient } from "../../../../actions/public/SignupProviderForClient";
import Card from "../../../../common/element/Card";
import Dialog from "../../../../common/element/Dialog";
import moment from "moment";
import { GetProviderInvoiceById } from "../../../../actions/public/GetProviderInvoiceById";
import ThreeDotLoader from "../../../../common/element/ButtonLoader/ThreeDotLoader";
import {
  GettData,
  ResetData,
} from "../../../../redux/classes/common/ProviderRegisterData";

const PaymentForm = ({ data, Setstep, SetFormData, SetContactError }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [agree, setAgree] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [saveCard, setSaveCard] = useState(true);
  const [paymentData, setPaymentData] = useState(null);
  const [dialogAddOpen, setDialogAddOpen] = useState(false);

  const emptyFormData=()=>{
    SetFormData({
      registrationType:"",
    invite_provider_id: "", //only require when create request first time
    provider_temp_regist_id: "",
    client_org_id: "",
    client_fa_id: "",
    user_id: "",
    tempMsaDoc: {},
    tempEngagementDoc: {},
    provider_regist_data: {
      address_data: [
        {
          country_id: "",
          state_id: "",
          address_one: "",
          address_two: "",
          suburb: "",
          zipcode: "",
          address_type: "",
        },
      ],
      individual_data: [],
      client_contact_data: {
        contact_title: "Mr",
        contact_first_name: "",
        contact_last_name: "",
        contact_phone: "",
        contact_phone_optional: "",
        contact_email: "",
      },
      whs_contact_info: {
        title: "mr",
        first_name: "",
        last_name: "",
        phone: "",
        phone_optional: "",
        email: "",
      },
      org_type: "other",
      abn_nzbn: "",
      trading_name: "",
      high_risk_master_setting_id: "",
      ind_master_setting_id: "",
      provider_type_id: "",
      no_of_emp: "",
      high_risk_activity: true,
      whs_system_available: false,
      whs_system_certified: false,
      msa_info: {},
    },
    })
    SetContactError({
      contact_title: "",
      contact_first_name: "",
      contact_last_name: "",
      contact_phone: "",
      contact_email: "",
      ans_ques_one: "",
      ans_ques_two: "",
      ans_ques_three: "",
      ans_ques_four: "",
      ans_ques_five: "",
      ans_ques_six: "",
    })
    dispatch(ResetData())
  }
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Early return if stripe or elements aren't loaded yet
    if (!stripe || !elements) {
      return;
    }

    // Ensure we're not already processing
    if (isProcessing) {
      return;
    }

    setIsProcessing(true);

    try {
      const cardElement = elements.getElement(CardElement);

      // Check if cardElement exists before proceeding
      if (!cardElement) {
        setError("Card element not found. Please refresh and try again.");
        setIsProcessing(false);
        return;
      }

      const { error, token } = await stripe.createToken(cardElement);

      if (error) {
        setError(error.message);
        console.error(error);
        setIsProcessing(false);
        return;
      }

      if (!token) {
        setError("Payment token creation failed. Please try again.");
        setIsProcessing(false);
        return;
      }

      // Proceed with payment if we have the necessary data
      if (paymentData?.provider_type_id || paymentData?.amount) {
        let payload = {
          ...data,
          payment_info: JSON.stringify({ ...paymentData, cardToken: token.id, saveCard }),
          provider_type_id: paymentData?.provider_type_id,
          is_client_pay_licence: data?.registrationType === "forClient" ? false : true
        };
        let resp;
        try {
          resp = await dispatch(SignupProviderForClient(payload));
        } catch (signupError) {
          console.error("SignupProviderForClient failed:", signupError);
          setError("An unexpected error occurred during registration. Please try again.");
          setIsProcessing(false);
          return;
        }

        if (!resp?.success) {
          setError("Payment processing failed. Please try again.");
          setIsProcessing(false);
          return;
        }

        const signupToken = resp?.data?.token;
        const signupEmail = resp?.data?.email;

        const persistLoginUserData = () => {
          localStorage.setItem(
            "LoginUserData",
            JSON.stringify({
              userName: {
                email: signupEmail,
                first_name: resp?.data?.first_name || "",
                last_name: resp?.data?.last_name || "",
                user_data: {
                  user_id: resp?.data?.user_id,
                },
              },
              function_assignment_id: resp?.data?.provider_fa_id,
              organisation_id: resp?.data?.provider_org_id,
              trading_name: resp?.data?.provider_trading_name,
              functionId: resp?.data?.function_id || null,
            })
          );
        };

        const hasProviderSession = Boolean(signupToken);

        if (hasProviderSession) {
          localStorage.removeItem("permission_data");
          localStorage.setItem("conserve_authtoken", signupToken);
          persistLoginUserData();
        } else {
          console.error(
            "SignupProviderForClient succeeded but no token was returned. Provider will not be logged in.",
            resp
          );
        }

        localStorage.setItem(
          "checkAuth",
          JSON.stringify({
            checkAuth: hasProviderSession ? "provider" : "",
          })
        );

        try {
          const invoiceData = await dispatch(
            GetProviderInvoiceById({ sub_invoice_id: resp?.data?.sub_invoice_id })
          );

          emptyFormData();
          navigate("/provider-registration-invoice", {
            state: {
              data: {
                ...invoiceData,
                amount: paymentData?.amount,
                end_date: paymentData?.end_date,
              },
              hasProviderSession,
            },
          });
        } catch (invoiceError) {
          console.error("Error fetching invoice:", invoiceError);
          setError("Could not retrieve invoice data.");
        } finally {
          setIsProcessing(false);
        }
      } else {
        setError("Payment details are incomplete. Please try again.");
        setIsProcessing(false);
      }
    } catch (err) {
      console.error("Payment submission error:", err);
      setError("An unexpected error occurred. Please try again.");
      setIsProcessing(false);
    }
  };

  const getInvoiceData = (id) => {
   
  };

  useEffect(() => {
    let payload = {
      registrationType: data?.registrationType,
      provider_type_id: data?.provider_regist_data?.provider_type_id || "",
      invite_provider_id: "",
      isProviderExist: false,
      provider_org_id: "",
      no_of_emp: data?.provider_regist_data?.no_of_emp || "",
    };

    dispatch(ProviderRegisterPaymentInfo(payload)).then((response) => {
      if (response) {
        setPaymentData(response?.data);
      }
    }).catch(err => {
      console.error("Error fetching payment info:", err);
      setError("Could not load payment information.");
    });

    // Cleanup function to handle component unmounting
    return () => {
      // Cancel any pending operations if component unmounts
      setIsProcessing(false);
    };
  }, []);

  const onAddDialogClose = () => {
    setDialogAddOpen(false);
    navigate(localStorage.getItem("conserve_authtoken") ? "/provider" : "/login");
  };

  return (
    <div
      style={{ backgroundColor: `#eff8ff` }}
      className="flex justify-between pr-6 pl-6"
    >
      <div className="w-full justify-center flex flex-wrap">
        <div className="pb-20 pt-20 w-full">
          <Card className="registerBlock p-7 border border-gray-200 rounded-xl">
            <h5 className="text-blue-800 font-semibold text-2xl mb-7">
              Payment Breakdown
            </h5>

            <h4 className="font-bold text-gray-700 text-base mb-1">
              Total Fee
            </h4>
            <p className="text-gray-700 mb-7">
              {paymentData?.amount
                 ? `$ ${(Number(paymentData?.amount)).toFixed(2)}`
                              : "We couldn’t retrieve the fee information. Please try again later."}
            </p>

            <h4 className="font-bold text-gray-700 text-sm mb-2">
              This fee includes
            </h4>

            <div className="mb-2 input-shadow border border-gray-300 rounded-lg">
              <div className="h-10 text-sm w-full py-2 px-3 text-gray-900 flex justify-between items-center border-b border-gray-300">
                <span className="text-gray-700 text-sm font-semibold font-weight-500">Annual license fee <span className="italic">(Includes 2x Workers)</span></span>
                <span className="text-gray-700 text-sm font-semibold font-weight-600">$ {(Number(paymentData?.licence_fee || 0)).toFixed(2)}</span>
              </div>
              <div className="h-10 text-sm w-full py-2 px-3 text-gray-900 flex justify-between items-center">
                <span className="text-gray-700 text-sm font-semibold font-weight-500">{paymentData?.worker_fees?.chargeable_workers} Additional Workers</span>
                <span className="text-gray-700 text-sm font-semibold font-weight-600">$ {(Number(paymentData?.worker_amount || 0)).toFixed(2)}</span>
              </div>
            </div>
            
            <h4 className="text-gray-700 text-sm mb-7 italic font-weight-500 font-semibold">
              You will be prompted to allocate workers on the following screen.
            </h4>

            {/* <p className="text-gray-700 mb-7">
              {paymentData?.licence_fee
                              ? `$ ${(Number(paymentData?.licence_fee)).toFixed(2)}`
                              : "We couldn’t retrieve the fee information. Please try again later."}
            </p> */}
             
            {/* <h4 className="font-bold text-gray-700 text-base mb-1">
              Worker Fee
            </h4>
            <p className="text-gray-700 mb-7">
                            {paymentData?.worker_fees?.chargeable_workers === 0 ? '$ 0' : paymentData?.worker_amount
                              ? `$ ${(Number(paymentData?.worker_amount)).toFixed(2)}`
                              : "We couldn't retrieve the fee information. Please try again later."}                         
                          </p>

             */}

            <h4 className="font-bold text-gray-700 text-base mb-1">
              License Period
            </h4>
            <p className="text-gray-700">
              {moment(new Date()).format("DD/MM/YYYY")} -{" "}
              {moment(paymentData?.end_date).format("DD/MM/YYYY")}
            </p>
          </Card>

          <Card className="p-7 border border-gray-200 rounded-xl mt-7">
            <h5 className="text-blue-800 font-semibold text-2xl mb-2">
              Payment options
            </h5>
            <div className="bg-gray-100">
              <div className="bg-white w-full">
                <div className="flex items-center justify-between mb-3">
                  <h2 className="text-lg font-semibold">Card Information</h2>
                  <span className="text-gray-500 text-sm font-normal flex items-center gap-2">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33334 8 1.33334C4.3181 1.33334 1.33334 4.3181 1.33334 8C1.33334 11.6819 4.3181 14.6667 8 14.6667Z" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 10.6667V8" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 5.33334H8.00667" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Please go to settings to change card details.
                  </span>
                </div>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="border rounded-lg p-3 focus-within:border-blue-500 transition">
                    <CardElement
                      options={{
                        hidePostalCode: true,
                        style: {
                          base: {
                            fontSize: "16px",
                            color: "#333",
                            "::placeholder": {
                              color: "#a0aec0",
                            },
                          },
                          invalid: { color: "#e53e3e" },
                        },
                      }}
                    />
                  </div>

                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="terms"
                      checked={agree}
                      onChange={() => setAgree(!agree)}
                      className="cursor-pointer"
                    />
                    <label
                      htmlFor="terms"
                      className="text-sm text-gray-600 cursor-pointer"
                    >
                      I understand and accept that this licensing fee is valid for 12 months
                    </label>
                  </div>

                  

                  <div className="flex items-start gap-2 mt-2">
                    <input
                      type="checkbox"
                      id="saveCard"
                      checked={saveCard}
                      onChange={() => setSaveCard(!saveCard)}
                      className="mt-1 cursor-pointer"
                    />
                    <label htmlFor="saveCard" className="text-sm text-gray-600 cursor-pointer">
                      Save card for future payments
                    </label>
                  </div>

                  {error && (
                    <p className="text-red-500 text-sm">
                      {error}
                    </p>
                  )}

                  <div className="flex mt-7 step2-btn-block form-footer justify-between">
                    <BtnLight
                      type="button"
                      className="w-auto px-6 mr-2 flex justify-center items-center pre-step"
                      onClick={() => Setstep(false)}
                    >
                      <img
                        src="assets/icons-svg/arrow-left.svg"
                        alt=""
                        className="mr-2"
                      />
                      Previous page
                    </BtnLight>

                    <BtnPrimary
                      type="submit"
                      disabled={
                        !agree ||
                        isProcessing}
                      className="w-auto px-6"
                    >
                      {isProcessing ? (
                        <ThreeDotLoader />
                      ) : (
                        "Confirm and pay"
                      )}
                    </BtnPrimary>
                  </div>
                </form>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <Dialog
        isOpen={dialogAddOpen}
        onClose={onAddDialogClose}
        onRequestClose={onAddDialogClose}
        bodyOpenClassName="overflow-hidden"
        className="customAlert"
      >
        <div className="px-6 pt-6">
          <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="49"
              height="49"
              viewBox="0 0 49 49"
              fill="none"
            >
              <rect
                x="0.583008"
                y="1.37207"
                width="47"
                height="47"
                rx="23.5"
                fill="#D1FADF"
              />
              <rect
                x="0.583008"
                y="1.37207"
                width="47"
                height="47"
                rx="23.5"
                stroke="#ECFDF3"
              />
              <path
                d="M32.083 18.8721L21.083 29.8721L16.083 24.8721"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <p className="text-base text-gray-900 font-semibold text-center mt-4">
          Thank you for registering. You will be redirected to the dashboard         </p>
        </div>
        <div className="mt-8 flex justify-between pb-6 px-6">
          <BtnLight onClick={onAddDialogClose}>Close</BtnLight>
        </div>
      </Dialog>
    </div>
  );
};

export default PaymentForm;